export default {
	state: {
		isUserInfoMask: false,
		isLoginBox: false,//登录窗口
		isCustomerService: false,//客服窗口
		isReconiseInfo: false,//实名认证窗口
		reconiseInfoType:1,//实名认证窗口步骤
		isCouponInfo: false,//优惠卷列表
		isBindPhone: false,//绑定手机号窗口
		isPayType: false,//支付窗口
		isRegister: false,//注册窗口
		agreementShow: false,//用户协议窗口
		isAccountAndPas: false,//注册成功之后账号密码截图窗口

		isTips: false,//认证提示窗口

		isPayUrlInfo: false,//ios桌面图标下的支付弹窗
		isAccount: false,//账号中心
		isAlertPwd:false,
		pay_url: '',//ios下桌面图标打开游戏的支付链接
		isFindPwd:false,
		isShowService:false,//客服窗口
		isCouponFrom:"mask",//开启优惠券弹窗的来源
		loginType: "account", //默认登陆方式--账号登陆
		isUserMsgProtect:false,//个人信息保护协议
		isReconiseInfoTip:false,//橙色改版的认证温馨提示
		isAgreementTip:false,//用户协议勾选提示
		isLogoutAccount:false,//注销账号

	},
	mutations: {
		IsUserInfoMask(state, isUserInfoMask) {
			state.isUserInfoMask = isUserInfoMask
		},
		IsLoginBox(state, isLoginBox) {
			if (isLoginBox) {
				state.isUserInfoMask = false;
				state.isCustomerService = false;
				state.isFindPwd = false;
				state.isReconiseInfo = false;
				state.isReconiseInfoTip = false;
				state.isCouponInfo=false

		
				state.isBindPhone = false;
				state.isPayType = false;
				state.isRegister = false;
				state.agreementShow = false;
				state.isPayUrlInfo = false;
				state.isAccount = false;
				state.isAlertPwd = false;
				state.isTips = false;
			}
			state.isLoginBox = isLoginBox;
		},
		IsCustomerService(state, isCustomerService) {
			state.isCustomerService = isCustomerService
		},
		IsFindPwd(state, isFindPwd) {
			state.isFindPwd = isFindPwd
		},
		IsEmail(state, isEmail) {
			state.isEmail = isEmail
		},
		IsEmailDetails(state, isEmailDetails) {
			state.isEmailDetails = isEmailDetails
		},
		IsWelfare(state, isWelfare) {
			state.isWelfare = isWelfare
		},
		IsReconiseInfo(state, isReconiseInfo) {
			state.isReconiseInfo = isReconiseInfo
		},
		ReconiseInfoType(state, reconiseInfoType) {
			state.reconiseInfoType = reconiseInfoType
		},
		IsCouponInfo(state, isCouponInfo) {
			state.isCouponInfo = isCouponInfo
		},
		IsCoupon(state, isCoupon) {
			state.isCoupon = isCoupon
		},
		IsBindPhone(state, isBindPhone) {
			state.isBindPhone = isBindPhone
		},
		IsPayType(state, isPayType) {
			state.isPayType = isPayType
		},
		IsWallet(state, isWallet) {
			state.isWallet = isWallet
		},
		IsExchange(state, isExchange) {
			state.isExchange = isExchange
		},
		IsRecharge(state, isRecharge) {
			state.isRecharge = isRecharge
		},
		IsRegister(state, isRegister) {
			state.isRegister = isRegister
		},
		AgreementShow(state, agreementShow) {
			state.agreementShow = agreementShow
		},

		IsPayUrlInfo(state, isPayUrlInfo) {
			state.isPayUrlInfo = isPayUrlInfo
		},
		Pay_url(state, pay_url) {
			state.pay_url = pay_url
		},
		IsAccountAndPas(state, isAccountAndPas) {
			state.isAccountAndPas = isAccountAndPas
		},
		IsAccount(state, isAccount) {
			state.isAccount = isAccount
		},
		IsAlertPwd(state, isAlertPwd) {
			state.isAlertPwd = isAlertPwd
		},
		
		
		IsRealNameTip(state, isRealNameTip) {
			state.isRealNameTip = isRealNameTip
		},
		IsRealNameForm(state, isRealNameForm) {
			state.isRealNameForm = isRealNameForm
		},
		IsTiredTip(state, isTiredTip) {
			state.isTiredTip = isTiredTip
		},
		IsRelieveTiredTip(state, isRelieveTiredTip) {
			state.isRelieveTiredTip = isRelieveTiredTip
		},
		IsTips(state, isTips) {
			state.isTips = isTips
		},
		IsService(state, isShowService) {
			state.isShowService = isShowService
		},
		IsCouponFrom(state, isCouponFrom) {
			state.isCouponFrom = isCouponFrom
		},
		LoginType(state, loginType) {
			state.loginType = loginType
			console.log(state.loginType)
		},
		IsUserMsgProtect(state, isUserMsgProtect) {
			state.isUserMsgProtect = isUserMsgProtect
		},
		IsReconiseInfoTip(state, isReconiseInfoTip) {
			state.isReconiseInfoTip = isReconiseInfoTip
		},
		IsAgreementTip(state, isAgreementTip) {
			state.isAgreementTip = isAgreementTip
		},
		IsLogoutAccount(state, isLogoutAccount) {
			state.isLogoutAccount = isLogoutAccount
		},
		
	},

	actions: {
		IsUserInfoMaskFun(context, n) {
			context.commit('IsUserInfoMask', n)
		},
		IsLoginBoxFun(context, n) {
			context.commit('IsLoginBox', n)
		},
		IsCustomerServiceFun(context, n) {
			context.commit('IsCustomerService', n)
		},
		IsFindPwdFun(context, n) {
			context.commit('IsFindPwd', n)
		},
		IsReconiseInfoFun(context, n) {
			context.commit('IsReconiseInfo', n)
		},
		ReconiseInfoTypeFun(context, n) {
			context.commit('ReconiseInfoType', n)
		},
		IsCouponInfoFun(context, n) {
			context.commit('IsCouponInfo', n)
		},
		IsBindPhoneFun(context, n) {
			context.commit('IsBindPhone', n)
		},
		IsPayTypeFun(context, n) {
			context.commit('IsPayType', n)
		},
		IsRegisterFun(context, n) {
			context.commit('IsRegister', n)
		},
		AgreementShowFun(context, n) {
			context.commit('AgreementShow', n)
		},
		IsPayUrlInfoFun(context, n) {
			context.commit('IsPayUrlInfo', n)
		},
		Pay_urlFun(context, n) {
			context.commit('Pay_url', n)
		},
		IsAccountAndPasFun(context, n) {
			context.commit('IsAccountAndPas', n)
		},
		IsTipsFun(context, n) {
			context.commit('IsTips', n)
		},
		IsAccountFun(context, n) {
			context.commit('IsAccount', n)
		},
		IsAlertPwdFun(context, n) {
			context.commit('IsAlertPwd', n)
		},
		IsServiceFun(context, n) {
			context.commit('IsService', n)
		},
		IsCouponFromFun(context, n) {
			context.commit('IsCouponFrom', n)
		},
		LoginTypeFun(context, n) {
			context.commit('LoginType', n)
		},
		IsUserMsgProtectFun(context, n) {
			context.commit('IsUserMsgProtect', n)
		},
		IsReconiseInfoTipFun(context, n) {
			context.commit('IsReconiseInfoTip', n)
		},
		IsAgreementTipFun(context, n) {
			context.commit('IsAgreementTip', n)
		},
		IsLogoutAccountFun(context, n) {
			context.commit('IsLogoutAccount', n)
		},
	}

}


// WEBPACK FOOTER //
// ./src/store/modules/winType.js